import { Small } from 'foundations-components/transitional/components/Small';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getUserWorkingHoursURL } from '../../../working-hours/utils/workingHoursUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OutOfOfficeDetails = ({
  startTimestamp,
  endTimestamp
}) => /*#__PURE__*/_jsx(FormattedReactMessage, {
  message: "routing-ui.agent-status.outOfOfficeTooltip",
  options: {
    startDate: /*#__PURE__*/_jsx(FormattedDateTime, {
      type: "userTz",
      value: startTimestamp,
      format: "short-date"
    }),
    startTime: /*#__PURE__*/_jsx(FormattedDateTime, {
      type: "userTz",
      value: startTimestamp,
      format: "LT"
    }),
    endDate: /*#__PURE__*/_jsx(FormattedDateTime, {
      type: "userTz",
      value: endTimestamp,
      format: "short-date"
    }),
    endTime: /*#__PURE__*/_jsx(FormattedDateTime, {
      type: "userTz",
      value: endTimestamp,
      format: "LT"
    })
  }
});
OutOfOfficeDetails.displayName = 'OutOfOfficeDetails';
export const OutOfOfficeLabel = ({
  userId,
  currentSegment
}) => {
  const {
    startTimestamp,
    endTimestamp
  } = currentSegment;
  return /*#__PURE__*/_jsx(Flex, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(OutOfOfficeDetails, {
          startTimestamp: startTimestamp,
          endTimestamp: endTimestamp
        }), /*#__PURE__*/_jsx(Link, {
          external: true,
          href: getUserWorkingHoursURL(userId),
          paddingInlineStart: "100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.agent-status.manageOutOfOfficeHoursLink"
          })
        })]
      }),
      children: /*#__PURE__*/_jsx(Small, {
        paddingInlineStart: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.outOfOffice"
        })
      })
    })
  });
};
OutOfOfficeLabel.displayName = 'OutOfOfficeLabel';